import React from "react";
import styled from "styled-components";
import { SectionHeader } from "../../../../../app/components";
import { useStudyPlan } from "../../../../../app/contexts/study.context";
import EditIcon from "@material-ui/icons/Edit";
import { useNavigate, useParams } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import ScenarioA from "./scenario.a";
import ScenarioB from "./scenario.b";
import SeparateContainer from "../../../../../app/components/separate.Container";
import OutlinedButton from "../../../../../app/components/buttons/outlined";
import SideBySide from "../../../../../app/components/sideBySide";

const baseText =
  "Site Fatigue or a time-based erosion factor for enrollment can be applied using the below fields. This should be only applied when you expect the enrollment rate to decrease after a period of time. First, complete the number of days after site activation when site fatigue is expected to start.";

const scenarioSpecificTexts = {
  SCENARIO_A:
    "In the second field include the new lower enrollment rate that you expect.",
  SCENARIO_B:
    "In the second field include the percent (in decimals) of the former rate that is expected. Enter 0.75 if you expect the rate to be 75% of what it formally was.",
};

const SiteFatigue = (props) => {
  const { studyPlan, STUDY_PLAN_TYPES, canEditPlan } = useStudyPlan();
  const navigate = useNavigate();
  const { id, planId } = useParams();
  const { studyPlanType } = studyPlan;
  const { SCENARIO_A, SCENARIO_B } = STUDY_PLAN_TYPES;

  let scenarioRender;
  let typographyText;

  if (studyPlanType === SCENARIO_A) {
    scenarioRender = <ScenarioA {...props} />;
    typographyText = `${baseText} ${scenarioSpecificTexts.SCENARIO_A}`;
  }

  if (studyPlanType === SCENARIO_B) {
    scenarioRender = <ScenarioB {...props} />;
    typographyText = `${baseText} ${scenarioSpecificTexts.SCENARIO_B}`;
  }

  return (
    <SeparateContainer>
      <Container>
        <SideBySide>
          <SectionHeader
            paddingBottom={false}
            marginBottom={false}
          >
            Site Fatigue
          </SectionHeader>
          {canEditPlan && (
            <OutlinedButton
              style={{ marginBlock: "0.7em", marginInline: "1em" }}
              onClick={() =>
                navigate(
                  `/ctpo/study-plans/${id}/${planId}/countries-and-site-groups#site-fatigue`,
                  { tabIndex: props.tab },
                )
              }
            >
              <EditIcon style={{ marginRight: ".3em" }} /> Edit
            </OutlinedButton>
          )}
        </SideBySide>
        <div style={{ padding: "10px 20px 20px 20px" }}>
          <Typography>{typographyText}</Typography>
          <div>{scenarioRender}</div>
        </div>
      </Container>
    </SeparateContainer>
  );
};

export default SiteFatigue;

const Container = styled.div``;
